
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function NewsSection() {
  const news = [
    {
      id: 1,
      date: '2026.2.21',
      category: 'リリース',
      title: '新シングル「あの雲のむこうがわ、その先に」ライブにて初演！',
      excerpt: 'とある映画（高校生が主人公の青春群像劇）の挿入歌オーディションがきっかけで生まれたこの曲。久下暁雅の方向性を決定づけた大切なシングル曲第１弾です。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20recording%20studio%20session%20with%20musician%20holding%20acoustic%20guitar%20in%20intimate%20lighting%2C%20dark%20moody%20atmosphere%20with%20warm%20backlighting%20creating%20silhouettes%2C%20vintage%201970s%20aesthetic%20with%20psychedelic%20color%20tones%2C%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20artistic%20music%20photography%20with%20dramatic%20shadows%20and%20highlights&width=400&height=250&seq=news-1-v2&orientation=landscape'
    },
    {
      id: 3,
      date: '2024.03.15',
      category: 'メディア',
      title: 'ラジオ番組「月ヶ瀬なつの　Friday Night Chatting ! (2025.12.5, 12.12, 12.19, 12.26放送回)」出演',
      excerpt: '月ヶ瀬なつのさんがパーソナリティを務める池袋FMラジオ番組に、ゲスト出演しました。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20radio%20studio%20with%20musician%20holding%20guitar%20during%20interview%2C%20dark%20atmospheric%20lighting%20with%20warm%20backlighting%20creating%20artistic%20silhouettes%2C%20vintage%201970s%20broadcast%20studio%20aesthetic%20with%20moody%20shadows%2C%20intimate%20close-up%20composition%20focusing%20on%20upper%20body%20and%20guitar%2C%20psychedelic%20color%20tones%20with%20dramatic%20lighting&width=400&height=250&seq=news-3-v2&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">News</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            最新のニュースやライブ情報をお届けします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {news.map((item) => (
            <article key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group cursor-pointer">
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-black text-white px-3 py-1 rounded-full text-xs font-medium">
                    {item.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <i className="ri-calendar-line mr-2"></i>
                  {item.date}
                </div>
                
                <h3 className="text-xl font-bold mb-3 group-hover:text-gray-600 transition-colors">
                  {item.title}
                </h3>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {item.excerpt}
                </p>
                
                <div className="flex items-center text-black font-medium group-hover:text-gray-600 transition-colors">
                  詳細を見る
                  <i className="ri-arrow-right-line ml-2 transition-transform group-hover:translate-x-1"></i>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/news">
            <Button variant="outline" size="lg">
              <i className="ri-newspaper-line mr-2 text-xl"></i>
              すべてのニュースを見る
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
